// web/src/lib/features.ts — hidden screens (portal spec 10). Build-time flags; unset = off.
// Mirrors the API's BUILDS_UI_ENABLED / CHALICE_ENABLED: with a flag off the route, nav entry and
// buttons for that feature don't render (the code stays, so KC can switch it back on, 10 §4g).
export const FEATURES = {
  builds: import.meta.env.VITE_BUILDS_UI_ENABLED === 'true',
  chalice: import.meta.env.VITE_CHALICE_ENABLED === 'true',
} as const;
